import Controller, { inject as controller } from '@ember/controller';
import { task } from 'ember-concurrency';
import FormValidations from 'cio/utils/form-validations';

import LoginController from 'cio/pods/login/controller';
import { inject as service } from '@ember/service';
import LoginService from 'cio/services/login';
import { action } from '@ember/object';

const Validations = {
  twoFactorAuthCode(value: string) {
    if (!value?.trim()) {
      return "Authentication code can't be blank.";
    }

    return true;
  },
};

export default class TwoFactorAuthenticationController extends Controller {
  @service login!: LoginService;
  @controller('login') loginController!: LoginController;

  _validations: FormValidations;

  constructor() {
    super(...arguments);

    this._validations = FormValidations.create({
      validations: Validations,
      context: this,
      modelKey: 'loginController',
    });
  }

  _submitTask = task(async (event: Event) => {
    event.preventDefault();

    try {
      await this._validations.validateModel();
    } catch (e) {
      // `validateModel` already found and set validation errors
      // return early to avoid executing real submit logic
      return;
    }

    await this.loginController.loginTaskTwoFactorAuth.perform();
  });

  @action
  onTwoFactorCodeChange(twoFactorAuthCode: string) {
    this.loginController.set('twoFactorAuthCode', twoFactorAuthCode);
    this._validations.validateAttribute('twoFactorAuthCode');
  }
}
